<div class="min-h-screen bg-bg-base pb-12">
    <app-experts-header></app-experts-header>

    <div class="mx-auto -mt-8 max-w-7xl px-4 sm:px-6 lg:px-8">
        <app-experts-stats
            [totalExperts]="stats.totalExperts || pagination.totalItems"
            [averageRating]="stats.averageRating"
            [totalReviews]="stats.totalReviews"
            [certifiedExperts]="stats.certifiedExperts">
        </app-experts-stats>
    </div>

    <app-experts-filters (filtersChange)="onFiltersChanged($event)"></app-experts-filters>

    <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div class="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div>
                <h2 class="h4">{{ pagination.totalItems }} {{ 'experts.list.expertCountLabel' | translate }}</h2>
                <p class="body-small">
                    {{ 'experts.list.showing' | translate }}
                    {{ filteredExperts.length }}
                    {{ 'experts.list.resultsOnPage' | translate }}
                    {{ pagination.currentPage }}
                    {{ 'experts.list.of' | translate }}
                    {{ pagination.pages }}
                </p>
            </div>
            @if (pagination.itemsPerPage > 0) {
                <span class="badge badge-neutral">{{ 'experts.list.perPage' | translate }} {{ pagination.itemsPerPage }}</span>
            }
        </div>

        @if (isLoading) {
            <div class="surface-elevated flex flex-col items-center justify-center py-20 text-center">
                <span class="loader mb-4 h-10 w-10"></span>
                <p class="body">{{ 'experts.list.loading' | translate }}</p>
                <div class="mt-8 grid w-full max-w-3xl gap-3">
                    <div class="skeleton h-4 w-full"></div>
                    <div class="skeleton h-4 w-4/5"></div>
                    <div class="skeleton h-4 w-2/3"></div>
                </div>
            </div>
        } @else if (errorMessage) {
            <div class="alert alert-danger">
                <i class="fas fa-triangle-exclamation mt-0.5"></i>
                <div>
                    <h3 class="mb-1 font-semibold text-text-primary">{{ 'experts.list.errorTitle' | translate }}</h3>
                    <p class="text-sm text-text-secondary">{{ errorMessage | translate }}</p>
                    <button class="btn btn-danger mt-4" (click)="loadExperts(pagination.currentPage)">
                        <i class="fas fa-rotate-right text-xs"></i>
                        {{ 'experts.list.retry' | translate }}
                    </button>
                </div>
            </div>
        } @else {
            <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
                @for (expert of filteredExperts; track expert.id) {
                    <app-expert-card [expert]="expert"></app-expert-card>
                } @empty {
                    <div class="surface-elevated col-span-1 py-16 text-center lg:col-span-2 animate-fade-in">
                        <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl border border-border-primary bg-primary-soft">
                            <i class="fas fa-search text-2xl text-primary"></i>
                        </div>
                        <h3 class="mb-2 text-lg font-semibold text-text-primary">{{ 'experts.list.emptyTitle' | translate }}</h3>
                        <p class="body-small">{{ 'experts.list.emptyDescription' | translate }}</p>
                    </div>
                }
            </div>

            @if (pagination.pages > 1) {
                <nav class="mt-8 flex flex-col gap-4 rounded-xl border border-border-strong bg-surface p-4 shadow-subtle sm:flex-row sm:items-center sm:justify-between" [attr.aria-label]="'experts.pagination.ariaLabel' | translate">
                    <p class="body-small">
                        {{ 'experts.pagination.page' | translate }} {{ pagination.currentPage }}
                        {{ 'experts.pagination.of' | translate }} {{ pagination.pages }}
                    </p>

                    <div class="pagination flex-wrap justify-center">
                        <button
                            class="page-item"
                            type="button"
                            [disabled]="!pagination.previousPage"
                            [class.opacity-50]="!pagination.previousPage"
                            [class.pointer-events-none]="!pagination.previousPage"
                            (click)="goToPage(pagination.previousPage)"
                            [attr.aria-label]="'experts.pagination.previous' | translate">
                            <i class="fas fa-chevron-left text-xs rtl:rotate-180"></i>
                        </button>

                        @if (getVisiblePages()[0] > 1) {
                            <button class="page-item" type="button" (click)="goToPage(1)">1</button>
                            <span class="px-2 text-text-muted">...</span>
                        }

                        @for (page of getVisiblePages(); track page) {
                            <button class="page-item" type="button" [class.active]="page === pagination.currentPage" (click)="goToPage(page)">
                                {{ page }}
                            </button>
                        }

                        @if (getVisiblePages()[getVisiblePages().length - 1] < pagination.pages) {
                            <span class="px-2 text-text-muted">...</span>
                            <button class="page-item" type="button" (click)="goToPage(pagination.pages)">{{ pagination.pages }}</button>
                        }

                        <button
                            class="page-item"
                            type="button"
                            [disabled]="!pagination.nextPage"
                            [class.opacity-50]="!pagination.nextPage"
                            [class.pointer-events-none]="!pagination.nextPage"
                            (click)="goToPage(pagination.nextPage)"
                            [attr.aria-label]="'experts.pagination.next' | translate">
                            <i class="fas fa-chevron-right text-xs rtl:rotate-180"></i>
                        </button>
                    </div>
                </nav>
            }
        }
    </div>
</div>
